module.exports = __webpack_public_path__ + "img/IMG_1867_L_Wood.b9373908.jpg";